import { InfoLabel, Table, TableBody, TableCell, TableHeader, TableHeaderCell, TableRow } from '@fluentui/react-components';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { NavLink } from 'react-router';
import { useCommonStyles } from '../../../common/hooks';
import { getTooltipContentByFieldName } from '../../../common/tooltip/tooltip-get-content';
import { NominationJudgedSummary } from '../../../models';
import { RoutePaths } from '../../../route-paths';
import './NominationJudgedSummariesTable.scss';

interface Props {
  nominationJudgedSummaries: NominationJudgedSummary[];
}

const NominationJudgedSummariesTable: React.FC<Props> = props => {
  const { nominationJudgedSummaries } = props;
  const commonStyles = useCommonStyles();

  const hasCountryAwards = nominationJudgedSummaries.some(nomination => nomination.isCountryAward);

  const navigateLink = (nominationJudgedSummary: NominationJudgedSummary) => {
    if (nominationJudgedSummary.isCountryAward && nominationJudgedSummary.countryId)
      return RoutePaths.Awards + '/' + nominationJudgedSummary.awardId + RoutePaths.Nominations + '/' + nominationJudgedSummary.nominationId + RoutePaths.Countries + '/' + nominationJudgedSummary.countryId;

    return RoutePaths.Awards + '/' + nominationJudgedSummary.awardId + RoutePaths.Nominations + '/' + nominationJudgedSummary.nominationId;
  }

  return (
    <Table className='nomination-judged-summaries-table'>
      <TableHeader>
        <TableRow>
          <TableHeaderCell>Nomination</TableHeaderCell>
          <TableHeaderCell>Award</TableHeaderCell>
          <TableHeaderCell>Group</TableHeaderCell>
          {hasCountryAwards && <TableHeaderCell>Country</TableHeaderCell>}
          <TableHeaderCell>Status</TableHeaderCell>
        </TableRow>
      </TableHeader>
      <TableBody>
        {
          nominationJudgedSummaries.map((nominationJudgedSummary) => {
            return (
              <TableRow
                key={nominationJudgedSummary.nominationId}
              >
                <TableCell>
                  {
                    nominationJudgedSummary.isEditable === false ? nominationJudgedSummary.title :
                      <NavLink
                        to={navigateLink(nominationJudgedSummary)}
                        end
                      >
                        {nominationJudgedSummary.title}
                      </NavLink>
                  }
                </TableCell>
                <TableCell>
                  {nominationJudgedSummary.award}
                </TableCell>
                <TableCell>
                  {nominationJudgedSummary.awardGroup}
                </TableCell>
                {
                  hasCountryAwards && (
                    <TableCell>
                      {nominationJudgedSummary.isCountryAward ? nominationJudgedSummary.countryDisplayName ?? '-' : '-'}
                    </TableCell>
                  )
                }
                <TableCell>
                  {
                    nominationJudgedSummary.status === 'Draft' ? (
                      <InfoLabel
                        info={{
                          children: getTooltipContentByFieldName('program-dashboard-page', 'draftJudgedNomination'),
                          className: commonStyles.tooltip,
                        }}
                      >
                        {nominationJudgedSummary.status}
                      </InfoLabel>
                    ) : nominationJudgedSummary.status
                  }
                </TableCell>
              </TableRow>
            );
          })
        }
      </TableBody>
    </Table>
  );
}

export default observer(NominationJudgedSummariesTable);
